import { initializeApp } from "firebase/app";
import { getAuth, OAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDahdHFxerWV0nBJf8ae6_Gr14YD0TgXPI",
  authDomain: "prod4sustainability52195.firebaseapp.com",
  projectId: "prod4sustainability52195",
  storageBucket: "prod4sustainability52195.appspot.com",
  messagingSenderId: "224436249113",
  appId: "1:224436249113:web:c58dc61f06988e07930088",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

const provider = new OAuthProvider("microsoft.com");

provider.setCustomParameters({
  tenant: "bc0c325b-6efc-4ca8-9e46-11b50fe2aab5",
  prompt: "select_account",
});

export default provider;
